var UserAPI = require("../../common/api/user");
var ApplicationsAPI = require("../../common/api/application");
var DonationsAPI = require("../../common/api/donation");
var auth = require('../../common/auth');

var _ = require("underscore");
var moment = require("moment");

module.exports = function ($scope, $state, $stateParams, $rootScope, ngDialog) {
    var vm = this;
    vm.barometer = {};
    vm.donations = [];
    vm.comments = [];
    vm.isOwner = false;
    vm.fundraiserId = null;

    var init = function () {
        vm.loading = true;

        UserAPI.GetFundraisingProfileByReference($stateParams.fundraiserRef).then(function (result) {
            vm.fundraiserId = result.id;
            UserAPI.GetFundraisingProfile(vm.fundraiserId).then(function (result) {
                vm.loading = false;
                vm.profile = result;
                vm.profile.fundraiserRef = $stateParams.fundraiserRef;
                if (vm.profile) {
                    vm.barometer.left = vm.profile.raised;
                    vm.barometer.right = vm.profile.totalRequested - vm.profile.raised;
                    vm.barometer.divider = vm.profile.totalRequested;

                    var perc = Math.floor((vm.profile.raised  * 100) / vm.profile.totalRequested);
                    if (perc <= 0) {
                        vm.barometer.percentage = 0;
                    } else {
                        vm.barometer.percentage = perc;
                    }

                    if (vm.profile.profilePicture) {
                        var formattedId = (vm.profile.profilePicture.blobId).replace(/-/g, '');
                        vm.profile.profilePictureUrl = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/" + vm.profile.profilePicture.fileName);
                    }

                    if (vm.profile.events) {
                        vm.profile.events.forEach(function (pEvent) {
                            if (pEvent.imageId) {
                                var formattedId = (pEvent.imageId).replace(/-/g, '');
                                var url = window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/eventImage.png";
                                pEvent.imageUrl = url;
                                _.findWhere(vm.profile.events, { id: pEvent.id }).imageUrl = url;
                            }
                        });
                    };

                    if (vm.profile.galleryItems) {
                        vm.profile.galleryItems.forEach(function (item) {
                            var formattedId = (item.blobId).replace(/-/g, '');
                            item.url = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/" + item.fileName);
                        });
                    }
                    if ($rootScope.auth) {
                        var formattedId = (vm.profile.userId).replace(/-/g, '');
                        if ($rootScope.auth.user_id == formattedId) {
                            vm.isOwner = true;
                        }
                    }
                }

                ApplicationsAPI.GetDonations(vm.profile.applicationId, vm.profile.id, "DonationMessageView", 1000).then(function (result) {
                    vm.donations = result.results;
                    rebuildUpdates();
                });

                ApplicationsAPI.Get(vm.profile.applicationId, "FundraisingApplicationDetailsView").then(function (result) {
                    vm.comments = [];
                    result.applicationComments.forEach(function (item) {
                        if (item.userId == vm.profile.userId)
                            vm.comments.push(item);
                    });
                    vm.donationsDisabledMessage = result.donationsDisabledMessage;
                    vm.donationsEnabled = result.donationsEnabled;
                    vm.appDetailsLoaded = true;
                    rebuildUpdates();
                });

                if (vm.scrollToDonations){
                    window.setTimeout(function(){
                        scrollToShow('project-updates');
                    }, 0);
                    vm.scrollToDonations = false;
                }
            });
        });
    };

    vm.maskDonation = function ($event, update) {
        $event.preventDefault();

        var promise = ngDialog.openConfirm({
            template: "\
              <p>Are you sure you want to hide the message and anonymise this donation?</p>\
              <div class=\"ngdialog-buttons clearfix\">\
                  <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                  <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
              </div>",
            plain: true,
            disableAnimation: true
        });
        promise.then(function () {
            update.isMasked = true;
            DonationsAPI.MaskDonation(update.id).finally(function () {
                return init();
            });
        });
    };

    vm.addComment = function () {
        if (_.any(vm.comments, function (comment) { return comment.editMode; }))
            return;
        vm.comments.push({
            createdDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
            type: "COMMENT",
            editMode: true,
            isFocused: true
        });
        rebuildUpdates();
    };

    vm.editComment = function (comment) {
        comment.editMode = true;
        comment.isFocused = true;
    };

    vm.submitComment = function (comment) {
        comment.editMode = false;
        comment.sendingToServer = true;
        if (comment.id) {
            ApplicationsAPI.UpdateComment(vm.fundraiserId, comment.id, { text: comment.text }).then(function () {
                comment.sendingToServer = false;
            });
        } else {
            comment.createdDate = moment();
            ApplicationsAPI.CreateComment(vm.profile.applicationId, comment).then(function (result) {
                comment.id = result;
                comment.sendingToServer = false;
            });
        }
        rebuildUpdates();
    };

    vm.getAvatar = function (id) {
        return window.conf.ge_api + "users/" + id + "/avatar";
    };

    var rebuildUpdates = function () {
        _.each(vm.donations, function (update) {
            update.type = "DONATION";
        });
        _.each(vm.comments, function (update) {
            update.type = "COMMENT";
        });
        var combinedUpdates = _.union(vm.donations, vm.comments);
        var sortedUpdates = _.sortBy(combinedUpdates, function (item) {
            return item.createdDate;
        });
        vm.updates = sortedUpdates.reverse();
    };

    vm.toggleEventDetails = function (event) {
        event.expanded = !event.expanded;
    };

    vm.openDonorJourney = function () {
        angular.element(document).find('body').addClass('scrollLock')

        var dialog = ngDialog.open({
            template: require("../find-a-project/project/dialogs/donorJourney.pug")(),
            controller: require("../find-a-project/project/dialogs/donorJourney"),
            data: {
                applicationId: vm.profile.applicationId,
                fundraiserId: vm.profile.id
                },
            plain: true,
            disableAnimation: true,
            className: "ngdialog-theme-default ngdialog-theme-dcsl ngdialog-disabled-animation ngdialog-large",
            showClose: false,
            closeByDocument: false,
            closeByEscape: false,
            resolve: {
                application: function () {
                    return vm.application;
                }
            }
        });

        dialog.closePromise.then(function (data) {
            angular.element(document).find('body').removeClass('scrollLock')

            var value = data.value;
			if (value.action === 'close') {
				if (value.viewDonation) {
					vm.scrollToDonations = true;
				}
				init();
			}
        });

        return dialog;
    };

	var scrollToShow = function (elementId) {
		const element = document.getElementById(elementId);
		const rect = element.getBoundingClientRect() // get rects(width, height, top, etc)
		const viewHeight = Math.max(document.documentElement.clientHeight, 
									window.innerHeight || 0);
		
		window.scrollBy({
		  top: rect.top - (viewHeight / 4),
		  behavior: 'smooth' // smooth scroll
		});
	}

    init();
};
